module.exports = __webpack_public_path__ + "static/media/Ashley A.e3e043e3.jpg";